const App = () => {
    return (
        <>
            <p>Alerts11</p>
        </>
    );
};

export default App;
